<template>
  <div class="setting-component">
    <!-- [ Menu ] end -->
    <div class="wrap">
      <div class="wrap__tree">
        <div class="nav-tree">
          <el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Service Item</el-button>
        </div>
      </div>
    </div>
    <sweet-modal blocking ref="modal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-position="top" size="mini" class="demo-ruleForm">

        <el-tabs v-model="activeModalTab" style="min-height: 500px;">
          <el-tab-pane name="details" label="Details">
            <el-row :gutter="15" class="list">
              <el-col :span="12">
                <el-form-item
                    label="Xero Item"
                    prop="xeroItemId">
                  <el-select
                      no-data-text="no date"
                      placeholder="Select Xero Item"
                      class="select"
                      size="small"
                      style="width: 100%"
                      v-model="form.xeroItemId"
                  >
                    <el-option
                        v-for="item in xeroItemList"
                        :key="item.ItemID"
                        :label="item.Name"
                        :value="item.ItemID">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Item Code">
                  <el-input readonly placeholder="Item Code" :value="activeXeroItem ? activeXeroItem.Code : null">
                  </el-input>
                </el-form-item>
                <el-form-item label="Item Name">
                  <el-input readonly placeholder="Item Name" :value="activeXeroItem ? activeXeroItem.Name : null">
                  </el-input>
                </el-form-item>
                <el-form-item label="Unit Measure" prop="unitId">
                  <el-select v-model="form.unitId" placeholder="Unit Measure" clearable filterable style="width: 100%;">
                    <el-option v-for="item in unitsList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input placeholder="Description" :value="form.description">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-input placeholder="Tag Name" :value="form.tagName">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div>Item Status</div>
                <el-form-item prop="isInactive" style="margin-top: 22px;">
                  <el-switch v-model="form.isInactive" active-text="Inactive"></el-switch>
                </el-form-item>
                <el-form-item prop="isInactive">
                  <el-switch v-model="form.isPurchase" :active-text="`Purchasing 'On Hold'`"></el-switch>
                </el-form-item>
                <el-form-item label-width="120px" prop="isInactive">
                  <el-switch v-model="form.isSell" active-text="Selling 'On Hold'"></el-switch>
                </el-form-item>
                <el-form-item style="clear: both;" label="Notes" prop="notes">
                  <el-input
                      type="textarea"
                      :rows="3"
                      v-model="form.notes">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane name="purchasing" label="Purchasing">
          </el-tab-pane>
          <el-tab-pane name="selling" label="Selling">
          </el-tab-pane>
          <el-tab-pane name="itemId" label="Item ID">
          </el-tab-pane>
          <el-tab-pane name="customFields" label="Custom Fields">
          </el-tab-pane>
        </el-tabs>
        <el-form-item class="modal__btn">
          <el-button @click="cancel">{{$t('general_cancel')}}</el-button>
          <el-button @click="submit('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: 'itemService2',
  data() {
    return {
      tableData: [],
      activeModalTab: 'details',
      form:{
        xeroItemId: null,
        notes: '',
        typeId: null,
        unitId: null,
        isInactive: false,
        isPurchase: false,
        isSell: false,
        //
        description: null,
        xeroItemName: '',
        tagName: null
      },
      rules: {
        xeroItemId: [{
          required: true,
          message: 'Field is required',
          trigger: 'change'
        }],
        unitId: [{
          required: true,
          message: 'Field is required',
          trigger: 'change'
        }],
        notes: [{
          required: true,
          message: 'Field is required',
          trigger: 'change'
        }],
      },
      xeroItemList: [],
      unitsList: [],
      typeId: 1 // SERVICE
    }
  },
  components: {
    SweetModal,
  },
  computed: {
    activeXeroItem() {
      if (this.form.xeroItemId) {
        const item = this.xeroItemList.find(item2 => item2.ItemID == this.form.xeroItemId)
        return item
      }
      return null
    }
  },
  methods: {
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/items/list?companyId=${this.$route.query.companyId}&typeId=${this.typeId}`)
          .then(response => {
            this.tableData = response.data.list
            // TODO: splice
            // this.tableData.splice(0, 2)
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async directories() {
      try {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.get(`/api/v1/items/directories?companyId=${this.$route.query.companyId}`)
        console.log('response', response)
        const units = await axios.get(`/api/v1/items/units/list?companyId=${this.$route.query.companyId}`)
        const { data: { directories: { xeroItemList } } } = response
        this.xeroItemList = xeroItemList
        this.unitsList = units.data.list
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
    async openModalAdd() {
      await this.directories()
      this.$refs.modal.open()
    },
    closeModal() {
      this.$refs['form'].resetFields();
    },
    cancel() {
      this.$refs.modal.close()
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let payload = {
            xeroItemId: this.form.xeroItemId,
            notes: this.form.notes,
            typeId: this.typeId,
            unitId: this.form.unitId,
            isInactive: this.form.isInactive,
            isPurchase: this.form.isPurchase,
            isSell: this.form.isSell,
          }
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.post(`/api/v1/items?companyId=${this.$route.query.companyId}`, payload)
            this.$refs.modal.close()
            this.loadList()
            loader.hide()
          } catch (err) {
            console.log(err)
            loader.hide()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-component{
  min-width: 810px;
}
</style>